import { AmountSelection } from '../../modules/amount-selection';

const imageAttribute = "data-preview-selected-image";
const imageRadioAttribute = "data-preview-image-radio";
const imagePathInputAttribute = "data-preview-selected-value";
const imagePathInputName = "ImageUrl";
const formFieldAttribute = "data-preview-field";
const amountRadioGroupName = "GiftCertificatesRequest.Amount";
const amountLabelAttribute = "data-amount-name";
const imageApiRoute = "/ace-api/gift/preview";

export const giftCertificatePage = () => {
    let queryStringElements = [];
    let altTextElements = [];
    const previewImage = document.querySelector(`[${imageAttribute}]`) as HTMLImageElement;
    const designRadios = [].slice.call(document.querySelectorAll(`[${imageRadioAttribute}]`)) as HTMLInputElement[];
    const formInputs = document.querySelectorAll(`[${formFieldAttribute}]`);
    const hiddenInput = document.querySelector(`[${imagePathInputAttribute}]`) as HTMLInputElement;
    const amountGroup = [].slice.call(document.querySelectorAll(`[name="${amountRadioGroupName}"]`)) as HTMLInputElement[];
    let selectedDesign = document.querySelector(`[${imageRadioAttribute}]:checked`) as HTMLInputElement || designRadios[0];

    // Amount radio inputs + custom textbox
    const customAmountInput = document.querySelector('#Amounts_custom-field') as HTMLInputElement;
    const customAmountRadio = document.querySelector('#Amounts_custom') as HTMLInputElement;
    const amountName = customAmountInput?.getAttribute(amountLabelAttribute);

    // Bind radio buttons to create a new preview
    designRadios.forEach(designRadio => {
        designRadio.addEventListener('change', () => {
            designRadios.forEach(radioInGroup => {
                if (radioInGroup.checked) {
                    updateSelectedDesign(radioInGroup.value);
                }
            })
        });
    });

    // Bind inputs to refresh preview image when they change text
    [].forEach.call(formInputs, (input) => {
        input.addEventListener("change", () => {
            updateImagePreview();
        });
    });

    // Initialize preview to the first image (or already-selected image if refreshed/user has gone back in browser)
    selectedDesign.checked = true;
    updateSelectedDesign(selectedDesign.value);

    if (customAmountInput && amountGroup) {
        const amountSelection = new AmountSelection(customAmountInput, amountGroup, customAmountRadio);
        amountSelection.on('inputBlur', () => {
            updateImagePreview();
        });

        amountGroup.forEach(radio => {
            radio.addEventListener('change', updateImagePreview);
        });
    }

    function updateSelectedDesign(selectedDesignUrl) {
        // set hidden field value to the new item
        hiddenInput.value = selectedDesignUrl;

        updateImagePreview();
    }

    function updateImagePreview() {
        // Find selected amount and add to query string
        const checkedAmount = document.querySelector(`[name="${amountRadioGroupName}"]:checked`) as HTMLInputElement;
        appendToQueryString(checkedAmount, amountName);

        // Update query string with current values from all other fields
        [].forEach.call(formInputs, input => {
            appendToQueryString(input);
        });

        // Set image src to api route with query params applied
        const serializedQueryString = queryStringElements.join("&");
        const currentAltText = altTextElements.join(", ");
        previewImage.src = `${imageApiRoute}?${serializedQueryString}`;
        previewImage.alt = currentAltText;
        queryStringElements = [];
        altTextElements = [];
    }

    function appendToQueryString(input: HTMLInputElement, paramName?: string) {
        // Get the query string param name from the preview field attribute value
        paramName = paramName == null ? input.getAttribute(formFieldAttribute) : paramName;
        const paramValue = input?.value;
        if (paramName && paramValue) {
            queryStringElements.push(`${paramName}=${paramValue}`);
        }

        if (paramName != imagePathInputName) {
            altTextElements.push((`${paramName}: ${paramValue}`).replace(/"/g, "'"));
        }
    }
}

giftCertificatePage();